export default __webpack_public_path__ + "static/media/_details-link-icon.38a4d36c.svg";